import { render, staticRenderFns } from "./instorelist.vue?vue&type=template&id=964bd880&scoped=true"
import script from "./instorelist.vue?vue&type=script&lang=js"
export * from "./instorelist.vue?vue&type=script&lang=js"
import style0 from "./instorelist.vue?vue&type=style&index=0&id=964bd880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964bd880",
  null
  
)

export default component.exports